import React, {Component} from 'react';
import { Container, Row, Col, Card } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import Tarjeta from '../../Componentes/Cards/pendienteCard'

export default class AdminAutorizaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usuarios: []
        }
        this.actualizarLista = this.actualizarLista.bind(this)
    }

    componentDidMount() {
        this.actualizarLista()
    }

    actualizarLista(){
        Fetch('/api/getUsuariosNoAutorizados', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ usuarios: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ usuarios: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                            <Container>
                            <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Autorizaciones</h1>
                                        <p className="lead">Esta seccion permite aceptar o negar solicitudes de registro al sistema</p>
                                        <hr className="my-1" />
                                    </Card>
                                
                                    <Row>
                                        <Tarjeta encabezado={true} />
                                        {this.state.usuarios.length > 0 ? this.state.usuarios.map((index) => (<Tarjeta id={index._id} usuario={index.usuario} nombre={index.nombre} ap_paterno={index.ap_paterno} ap_materno={index.ap_materno} rol={index.rol} actualizarLista={this.actualizarLista} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{border: 'dashed 2px' }} >Lista vacia</Card></Col>}
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Col>

                </Row>
                <Footer />
            </html>
        )
    }
}
